import React, { useState, useEffect } from "react";
import "./App.css";
import ZoomWebinar from "./components/ZoomWebinar";
import { ZoomMtg } from "@zoomus/websdk";
import { KJUR } from "jsrsasign";

// Hardcoded webinar data - would be replaced with API call in production
const webinarData = {
  title: "Masterclass on Laxman Rekha Strategy with Gopal Verma",
  isLive: true,
  attendees: 7, // Number of people who joined
  // Sample attendee profile images could be added here
};

function App() {
  // when zoom api integrates
  // const [webinarData, setWebinarData] = useState({
  //   title: "Loading...",
  //   isLive: false,
  //   attendees: 0,
  // });

  // useEffect(() => {
  //   // Fetch webinar data when component mounts
  //   const fetchWebinarData = async () => {
  //     try {
  //       const response = await fetch("http://localhost:4000/webinar-info");
  //       if (response.ok) {
  //         const data = await response.json();
  //         console.log("data", data);
  //         setWebinarData(data);
  //       }
  //     } catch (error) {
  //       console.error("Error fetching webinar data:", error);
  //     }
  //   };

  //   fetchWebinarData();

  //   // You could set up polling to refresh data periodically
  //   const intervalId = setInterval(fetchWebinarData, 30000); // every 30 seconds

  //   return () => clearInterval(intervalId);
  // }, []);

  const [userName, setUserName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [email, setEmail] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showWebinar, setShowWebinar] = useState(false);
  const [meetingId, setMeetingId] = useState(null);
  const [className, setClassName] = useState(null);

  useEffect(() => {
    // Extract meeting ID and class name from the query parameters
    const params = new URLSearchParams(window.location.search);
    const id = params.get("meetingId");
    const classNameParam = params.get("className");
    setMeetingId(id);
    setClassName(classNameParam);
  }, []);

  const handleJoin = (e) => {
    e.preventDefault();
    if (userName.trim() === "") {
      alert("Please enter your name");
      return;
    }
    if (phoneNumber.trim() === "") {
      alert("Please enter your phone number");
      return;
    }
    if (!isChecked) {
      alert("Please confirm you'll be focused for the next two hours");
      return;
    }

    setIsLoading(true);

    // Simulate loading
    setTimeout(() => {
      setIsLoading(false);
      setShowWebinar(true);
    }, 2000);
  };

  // Create an array of dummy profile pictures for attendees
  const attendeeProfiles = Array(webinarData.attendees)
    .fill(null)
    .map((_, index) => (
      <div
        key={index}
        className="attendee-avatar"
        style={{
          backgroundImage: `url(https://i.pravatar.cc/50?img=${index + 10})`,
          zIndex: webinarData.attendees - index,
        }}
      ></div>
    ));

  const handleNameChange = (e) => {
    setUserName(e.target.value);
  };

  const handlePhoneChange = (e) => {
    setPhoneNumber(e.target.value);
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleCheckboxChange = (e) => {
    setIsChecked(e.target.checked);
  };

  const generateSignature = (meetingNumber, role) => {
    const iat = Math.floor(Date.now() / 1000);
    const exp = iat + 60 * 60 * 2; // Token valid for 2 hours
    const oHeader = { alg: "HS256", typ: "JWT" };

    const oPayload = {
      appKey: "30bMIrGJQuCpZxUVEx9mYA", // Replace with your SDK key
      sdkKey: "30bMIrGJQuCpZxUVEx9mYA", // Replace with your SDK key
      mn: meetingNumber,
      role: role,
      iat: iat,
      exp: exp,
      tokenExp: exp,
    };

    const sHeader = JSON.stringify(oHeader);
    const sPayload = JSON.stringify(oPayload);
    const sdkJWT = KJUR.jws.JWS.sign(
      "HS256",
      sHeader,
      sPayload,
      "YOUR_SDK_SECRET" // Replace with your SDK secret
    );

    return sdkJWT;
  };

  const joinWebinar = () => {
    const leaveUrl = "https://live.learnwithmudrex.co/thanks-for-joining";
    const sdkKey = "30bMIrGJQuCpZxUVEx9mYA"; // Replace with your SDK key
    const meetingNumber = meetingId; // Use the dynamic meeting ID
    const passWord = ""; // Replace with webinar password if required
    const role = 0; // Role 0 for joining a webinar

    const signature = generateSignature(meetingNumber, role);

    ZoomMtg.init({
      leaveUrl: leaveUrl,
      success: () => {
        ZoomMtg.join({
          sdkKey: sdkKey,
          signature: signature,
          meetingNumber: meetingNumber,
          passWord: passWord,
          userName: userName, // Use the dynamic user name
          userEmail: email, // Use the email provided by the user
          success: (success) => {
            console.log("Webinar joined successfully:", success);
          },
          error: (error) => {
            console.error("Error joining webinar:", error);
          },
        });
      },
      error: (error) => {
        console.error("Error initializing Zoom SDK:", error);
      },
    });
  };

  return (
    <div className="App">
      <header className="App-header">
        <div className="logo-container">
          <img
            src="/assets/logo.png"
            alt="TheFuture.University"
            className="logo"
          />
          {/* <div className="brand-text">
            <span className="brand-name">TheFuture.</span>
            <span className="brand-university">University</span>
          </div> */}
        </div>
      </header>
      <main>
        {!showWebinar ? (
          <div className="webinar-container">
            <div className="webinar-info">
              <h1>{className || "Loading..."}</h1>
              <div className="attendees-info">
                <div className="attendee-avatars">
                  {attendeeProfiles}
                  {webinarData.attendees > 7 && (
                    <div className="attendee-avatar more">
                      +{webinarData.attendees - 7}
                    </div>
                  )}
                </div>
                <span className="attendees-text">people joined the class</span>
              </div>
              {webinarData.isLive && (
                <div className="live-indicator">Class is Live!</div>
              )}
            </div>

            <div className="registration-form">
              <h2>{className || "Loading..."}</h2>
              <h3>PLEASE PROVIDE YOUR DETAILS TO PROCEED</h3>

              <form onSubmit={handleJoin}>
                <div className="form-group">
                  <label htmlFor="name">YOUR NAME</label>
                  <input
                    type="text"
                    id="name"
                    value={userName}
                    onChange={handleNameChange}
                    placeholder="Enter your name"
                    className="form-control"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="phone">PHONE NUMBER</label>
                  <input
                    type="tel"
                    id="phone"
                    value={phoneNumber}
                    onChange={handlePhoneChange}
                    placeholder="Enter your phone number"
                    className="form-control"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">EMAIL</label>
                  <input
                    type="email"
                    id="email"
                    value={email}
                    onChange={handleEmailChange}
                    placeholder="Enter your email"
                    className="form-control"
                  />
                </div>

                <div className="form-check">
                  <input
                    type="checkbox"
                    id="focused"
                    checked={isChecked}
                    onChange={handleCheckboxChange}
                    className="form-check-input"
                  />
                  <label htmlFor="focused" className="form-check-label">
                    I'll be focused for the next two hours.
                  </label>
                </div>

                <button
                  type="submit"
                  className={`join-button ${isLoading ? "loading" : ""}`}
                  disabled={isLoading}
                >
                  {isLoading ? "Loading..." : "Join Now"}
                </button>
              </form>
            </div>
          </div>
        ) : (
          <ZoomWebinar
            userName={userName}
            meetingId={meetingId}
            className={className}
          />
        )}
        {showWebinar && (
          <button onClick={joinWebinar} className="join-webinar-button">
            Join Webinar
          </button>
        )}
      </main>
    </div>
  );
}

export default App;
